import { render, staticRenderFns } from "./GoogleDriveEmbed.vue?vue&type=template&id=36953b40"
import script from "./GoogleDriveEmbed.vue?vue&type=script&lang=ts"
export * from "./GoogleDriveEmbed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports